import { getRuntimeEnv } from "../utils/env";

export const prefix = getRuntimeEnv() === "dev" ? "" : "/corporate/portal";
export const apiPrefix = getRuntimeEnv() === "dev" ? "" : "/corporate";

/**
 * 依图官网的 url
 */
export const yituHomeUrl = "https://www.yitutech.com/";
